<template>
  <OutgoingReturnForm
    formTitle="Buat Retur Kekurangan"
    defaultDescription="Kekurangan"
  />
</template>

<script>
import OutgoingReturnForm from './OutgoingReturnForm.vue'
export default {
  components: { OutgoingReturnForm }
}
</script>
